import React from 'react';
import request from 'arcdynamic-request';
import PropTypes from "prop-types";
import Dropdown from "../Dropdown/Dropdown";
import { ApolloConsumer } from '@apollo/client';
import { GET_ALL_TENANTS } from '../Graphql/Queries/propertiesQuery';
import { fetchData } from '../Service/graphQlService';
import { GET_CONTACT_TENANTS_LIST_QUERY } from '../Graphql/ContactsQueries/contactsQuery';

class SelectMultiTenantFilter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            index: false,
        };
        this.client = null;
    }

    componentDidMount() {
        // request(arc.path.api, {
        //     service: 'arcimedes',
        //     action: 'open.dataquery.execute',
        //     params: [GET_ALL_TENANTS, {}],
        //let token = localStorage.getItem('authToken');
        if(this.client){
        // this.client.query({ query: GET_ALL_TENANTS ,
        //     fetchPolicy: "no-cache",
        //     context: {
        //       headers: {
        //         authorization: `Bearer ${token}`,
        //       },
        //     }
        // })
        fetchData(GET_CONTACT_TENANTS_LIST_QUERY, { type:"Tenant"})
        .then(res => {
            const index = {};
            // if (res.data) res.data.forEach(x => index[x.ARCIMEDES_ROW_ID] = x);

            // const filteredUniqueTenants = res.data && Array.isArray(res.data) && res.data.length && res.data.filter((item, index, array) => 
            //     index === array.findIndex((t) => t.NAME.trim().toLowerCase() === item.NAME.trim().toLowerCase())
            // );

            if (res.data.getContacts.data) res.data.getContacts.data.forEach(x => index[x.arcimedes_row_id] = x);

            const filteredUniqueTenants = res && res.data && res.data.getContacts && res.data.getContacts.data && Array.isArray(res.data.getContacts.data) && res.data.getContacts.data.length && res.data.getContacts.data.filter((item, index, array) => 
                index === array.findIndex((t) => t.name && t.name.trim().toLowerCase() === item.name && item.name.trim().toLowerCase())
            );


            this.setState({
                items: filteredUniqueTenants,
                index,
            });
        });
    }
    }

    render() {
        const { items } = this.state;
        const { theme, value, valueKey, label, disabled, data, isFilter, handleParentChange} = this.props;
        return (
            <ApolloConsumer>
            {client => {
                if (!this.client) {
                    this.client = client;
                    //this.fetch(this.props.location.query);
                }
                return (
            <Dropdown theme={theme}
                      dropdownType='multiple'
                      optionsType='tenant'
                      optionKey='arcimedes_row_id'
                      optionLabelKey='NAME'
                      options={items}
                      value={value}
                      valueKey={valueKey}
                      label={label}
                      disabled={!items || disabled}
                      data={data}
                      isFilter={isFilter}
                      handleParentChange={handleParentChange}
            />
        )
    }}
</ApolloConsumer>
        );
    }
}

SelectMultiTenantFilter.propTypes = {
    theme: PropTypes.oneOf(['default', 'white', 'dark']),
    value: PropTypes.string,
    valueKey: PropTypes.string.isRequired,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    data: PropTypes.object,
    withAddNew: PropTypes.bool,
    handleParentChange: PropTypes.func.isRequired,
    isFilter: PropTypes.bool,
    viewMode: PropTypes.bool,
    addNewItem: PropTypes.func,
};

export default SelectMultiTenantFilter;
